import AccesRapide from "./AccesRapide";

const HelpTopicReceivePayment = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Recevez vos paiements'},
  ];

  const content = <>
    <p className="help-text">
      Félicitations, votre paiement est en route ! Vous vous demandez quand il arrivera ? Découvrez ici tout ce qu’il 
      faut savoir sur les délais de versement et comment configurer vos préférences pour les recevoir sans souci.
    </p>
    <p className="mt-48 fw-600 fz-20 mb-12">Configuration du versement</p>
    <p className="help-text border-bottom pb-32 mb-0">
      En tant que nouvel organisateur, il est essentiel de configurer un mode de versement pour votre compte. Comme ce processus peut prendre un certain délai, 
      nous vous conseillons de vous en occuper rapidement.
    </p>
  </>

  return (
    <AccesRapide 
      goBackLinks={goBackLinks} guideInfo='Guide • Organisateur'
      img="/images/receive-payment.webp" content={content} topicsIds={[]}
    />
  );
}

export default HelpTopicReceivePayment